<div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="center center">
    <label class="mt-3">
        <em class="material-icons-outlined font-size-22" matTooltip="{{title}}" style="cursor: pointer;">file_upload</em>
        <input class="display" (change)="onFileChange($event)" type="file" placeholder="Upload file" accept=".xlsx">
    </label>
    <a class="btn textcolor mt-1" style="border: none !important; font-size: 14px;" target="_self"
        href="{{downloadTemplateBaseLink}}{{filename}}" download>Download
        Template</a>
</div>